import {useDebugValue} from 'react';

import {runHPPrePopulateCookieExperiment} from '../../../utils';

import {useValues} from './';

const defaultValues = {
    adultsCount: 0,
    childrenCount: 0,
    petIncluded: false
};

function useGuestsValues(props, cookies, system, abacus) {
    const {
        guestsValues: propsValues
    } = props;

    let {
        guestsValues: cookiesValues
    } = cookies;

    cookiesValues = runHPPrePopulateCookieExperiment(abacus, system, cookies) ? {} : cookiesValues;

    const {
        initialValues,
        currentValues,
        latestValues,
        setCurrentValues,
        setCurrentValuesDefault,
        setCurrentValuesInitial,
        setCurrentValuesLatest,
        setLatestValues,
        setLatestValuesDefault,
        setLatestValuesInitial,
        setLatestValuesCurrent,
        setAllValues,
        setAllValuesDefault,
        setAllValuesInitial
    } = useValues(defaultValues, cookiesValues, propsValues);

    const result = {
        defaultValues,
        initialValues,
        currentValues,
        latestValues,
        setCurrentValues,
        setCurrentValuesDefault,
        setCurrentValuesInitial,
        setCurrentValuesLatest,
        setLatestValues,
        setLatestValuesDefault,
        setLatestValuesInitial,
        setLatestValuesCurrent,
        setAllValues,
        setAllValuesDefault,
        setAllValuesInitial
    };

    useDebugValue(result);

    return result;
}

export {useGuestsValues};
